import { render, staticRenderFns, recyclableRender, components } from "./webview.vue?vue&type=template&id=0d2ee5cd&"
var renderjs
import script from "./webview.vue?vue&type=script&lang=js&"
export * from "./webview.vue?vue&type=script&lang=js&"
import style0 from "./webview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/webview/webview.vue"
export default component.exports